import { api } from "@/lib/axios";
import type {
  ReindexResponse,
  SearchInput,
  SearchResponse,
  SuggestionsResponse,
} from "@/modules/sales/search/types";

/**
 * Universal conversation search — API klient.
 * Backend kontrakti: docs/architecture/conversation-search.md § 5.1
 *
 * Endpoint'lar:
 *   POST /sales/search
 *   GET  /sales/search/suggestions?q=...
 *   POST /sales/search/reindex   (admin)
 */

function unwrap<T>(payload: { data?: T } | T): T {
  if (
    payload &&
    typeof payload === "object" &&
    "data" in (payload as Record<string, unknown>) &&
    !Array.isArray(payload)
  ) {
    return (payload as { data: T }).data;
  }
  return payload as T;
}

export const conversationSearchApi = {
  search: async (input: SearchInput): Promise<SearchResponse> => {
    const res = await api.post<{ data: SearchResponse } | SearchResponse>(
      "/sales/search",
      {
        query: input.query,
        type: input.type ?? "all",
        limit: input.limit ?? 20,
        offset: input.offset ?? 0,
        filters: input.filters ?? {},
        semanticBoost: input.semanticBoost ?? 0.5,
      },
    );
    return unwrap(res.data);
  },

  suggestions: async (
    q: string,
    limit = 8,
  ): Promise<SuggestionsResponse> => {
    const res = await api.get<{ data: SuggestionsResponse } | SuggestionsResponse>(
      "/sales/search/suggestions",
      { params: { q, limit } },
    );
    return unwrap(res.data);
  },

  reindex: async (): Promise<ReindexResponse> => {
    const res = await api.post<{ data: ReindexResponse } | ReindexResponse>(
      "/sales/search/reindex",
      {},
    );
    return unwrap(res.data);
  },
};
